import api from './config';

/**
 * 用户登录
 * @param {Object} data {username, password}
 */
export function login(data) {
  return api.post('/login', data);
}

/**
 * 获取当前用户信息
 * @param {boolean} skipAutoMessage 是否跳过自动错误处理（默认 true，避免登录后立即跳转）
 */
export function getCurrentUser(skipAutoMessage = true) {
  // 默认使用 skipAutoMessage，避免登录后立即跳转
  // 对于 /market 页面，如果 token 刚保存，可能后端还没准备好，使用 skipAutoMessage 避免立即跳转
  return api.get('/users/me', {
    skipAutoMessage: skipAutoMessage // 不自动显示错误消息，让调用方自己处理
  });
}

/**
 * 获取用户列表
 * @param {Object} params 查询参数
 */
export function getUsers(params = {}) {
  return api.get('/users', { params });
}

/**
 * 添加用户
 * @param {Object} data 用户数据
 */
export function addUser(data) {
  return api.post('/users', data);
}

/**
 * 更新用户
 * @param {number} id 用户ID
 * @param {Object} data 用户数据
 */
export function updateUser(id, data) {
  return api.put(`/users/${id}`, data);
}

/**
 * 启用用户
 * @param {number} id 用户ID
 */
export function enableUser(id) {
  return api.post(`/users/${id}/enable`);
}

/**
 * 禁用用户
 * @param {number} id 用户ID
 */
export function disableUser(id) {
  return api.post(`/users/${id}/disable`);
}

/**
 * 修改密码
 * @param {Object} data 密码数据
 */
export function changePassword(data) {
  return api.post('/users/change-password', data);
}

/**
 * 重置用户密码（管理员功能）
 * @param {number} userId 用户ID
 * @param {string} newPassword 新密码
 */
export function resetUserPassword(userId, newPassword) {
  return api.post(`/users/${userId}/reset-password`, { newPassword });
}

/**
 * 更新当前用户信息（用户名和手机号）
 * @param {Object} data {username, mobile}
 */
export function updateProfile(data) {
  return api.put('/users/me', data);
} 